import { useMutation } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { useSyncCenterSettings } from 'src/hooks/api/useSyncCenterSetting';
import { SellerAccountClient } from 'src/WebApiController';

export function useSyncCenterSettingsWithMutation() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const query = useSyncCenterSettings();

  const mutation = useMutation({
    mutationFn: async (partialSettings: Partial<typeof query.data>) => {
      if (query.data == undefined) {
        showErrorDialog('SellerAccountClient.mergeSyncCenterSettings', null, {
          trackErrorData: query,
        });
        return;
      }
      return new SellerAccountClient(activeAccountWebClientConfig)
        .mergeSyncCenterSettings({
          ...query.data,
          ...partialSettings,
        })
        .then(() => query.refetch());
    },
    onError: (err: ErrorTypes, data) => {
      showErrorDialog('SellerAccountClient.mergeSyncCenterSettings', err, {
        trackErrorData: { data },
      });
    },
  });

  return { query, mutation };
}
